import Notices from './Notices';

export default Notices;
